import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=3cca26fe&scoped=true&"
import script from "./StudentCard.vue?vue&type=script&lang=js&"
export * from "./StudentCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=3cca26fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca26fe",
  null
  
)

export default component.exports